import React, { useState } from "react";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { UserSchema } from "../../schema/UserSchema";
import { Col, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import TextError from "../../helpers/FormikHelper/TextError";
import userServices from "../../services/user.services";
import { toast } from 'react-toastify';
import { CenterSchema } from "../../schema/CenterSchema";
import Select from 'react-select';
const initialValues = {
    email: '',
    password: '',
    fullName: '',
    mobile: '',
    address: '',
    gender: 'male',
    // center_id:''
    mci_nmc_reg_no:'',
    degree_diploma:''
    
}

const DoctorForm = ({ toggle, isAddMode, centers, getAllDoctors, selectedRow }) => {  
    const [selectedOption, setSelectedOption] = useState('');

     const savedValues = {
        email: selectedRow?.email,
        password: selectedRow?.password,
        fullName: selectedRow?.name,
        mobile: selectedRow?.mobile,
        address: selectedRow?.address,
        gender: selectedRow?.gender,
        mci_nmc_reg_no: selectedRow?.mci_nmc_reg_no,
        degree_diploma: selectedRow?.degree_diploma
        // center_id: selectedRow?.center_id,

    }
    const options = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' },
      ];
    const onSubmit = async (values) => {
        const reqBody = {
            name: values.fullName,
            gender: values.gender,
            mobile: values.mobile,
            email: values.email,
            user_type_id: 5,
            password: values.password,
            address: values.address,
            mci_nmc_reg_no: values.mci_nmc_reg_no,
            degree_diploma: values.degree_diploma
            // center_id: values.center_id,

        }
       if(isAddMode==='Add'){
        const result = await userServices.createUser(reqBody);
        if (result.data.status === true) {
            // actions.resetForm();
            getAllDoctors()
            toggle()
            toast.success('Record added successfully', { toastId: 'registration_success', autoClose: 3000 });
        } else {
            toast.error(result.data.message, { toastId: 'registration_fail', autoClose: 3000 });
        }
    }else{
        const reqBody = {
            name: values.fullName,
            gender: values.gender,
            mobile: values.mobile,
            email: values.email,
            address: values.address,
            mci_nmc_reg_no: values.mci_nmc_reg_no,
            degree_diploma: values.degree_diploma
            // center_id: values.center_id,

        }
        const result = await userServices.updateUserById(selectedRow?._id,reqBody)
        if (result.data.status === true) {
            // actions.resetForm();
            getAllDoctors()
            toggle()
            toast.success('Record updated successfully', { toastId: 'update_success', autoClose: 3000 });
        } else {
            toast.error(result.data.message, { toastId: 'update_fail', autoClose: 3000 });
        }
    }
    }
    return (
        <React.Fragment>
            <Formik
                initialValues={isAddMode==='Add'?initialValues:savedValues}
                validationSchema={CenterSchema('ADD_DOCTOR')}
                onSubmit={onSubmit}
                enableReinitialize
            >
             {({  setFieldValue, values }) => (  <Form>
                    <ModalHeader toggle={toggle}>
                        <div className="card-title d-flex align-items-center">
                            <div>
                                <i className="bx bxs-user me-1 font-22 text-primary" />
                            </div>
                            <h5 className="mb-0 text-primary">{isAddMode === 'Add' ? 'Add Radiologist' : 'Update Radiologist'}</h5>
                        </div>
                    </ModalHeader>
                    <ModalBody className="">
                        <Col md={12}>
                            <div className="row g-3" >
                                <div className="col-md-6">
                                    <label htmlFor="fullName" className="form-label">
                                        Dr. Full Name
                                    </label>
                                    <Field type="text" className="form-control" id="fullName" name='fullName'
                                    />
                                    <ErrorMessage name='fullName' component={TextError} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="mobile" className="form-label">
                                        Mobile No
                                    </label>
                                    <Field type="text" className="form-control" id="mobile" name='mobile' maxLength="10"
                                    />
                                    <ErrorMessage name='mobile' component={TextError} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="mci_nmc_reg_no" className="form-label">
                                        MCI/NMC Registration No.
                                    </label>
                                    <Field type="text" className="form-control" id="mci_nmc_reg_no" name='mci_nmc_reg_no'
                                    />
                                    <ErrorMessage name='mci_nmc_reg_no' component={TextError} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="degree_diploma" className="form-label">
                                        Degree/Diploma
                                    </label>
                                    <Field type="text" className="form-control" id="degree_diploma" name='degree_diploma'
                                    />
                                    <ErrorMessage name='degree_diploma' component={TextError} />
                                </div>
                                {/* <div className="col-md-6">
                                    <label htmlFor="dr_specialization" className="form-label">
                                    Degree/Diploma
                                    </label>
                                    <Select
                                        defaultValue={selectedOption}
                                        onChange={
                                            selectedOption => {
                                                setSelectedOption(selectedOption)
                                                let val = selectedOption.map((item)=>{
                                                    // console.log('item', item.value)
                                                    return item.value
                                                })
                                                console.log(val);
                                            }}
                                        options={options}
                                        isMulti={true}
                                        />
                                    <ErrorMessage name='dr_specialization' component={TextError} />
                                </div> */}
                                <div className="col-md-6">
                                    <label htmlFor="email" className="form-label">
                                    E-Mail
                                    </label>
                                    <Field type="email" className="form-control" id="email" name='email'
                                    />
                                    <ErrorMessage name='email' component={TextError} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="password" className="form-label">
                                        Password
                                    </label>
                                    <Field type="password" className="form-control" id="password" name='password' disabled={isAddMode==='Add'?false:true}/>
                                    <ErrorMessage name='password' component={TextError} />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="address" className="form-label">
                                        Address
                                    </label>
                                    <Field
                                        className="form-control"
                                        id="address"
                                        // placeholder="Address..."
                                        name='address'
                                        type='text'
                                    />
                                    <ErrorMessage name="address" component={TextError} />
                                </div>
                              
                                <div className="col-md-12">
                                    <label htmlFor="mobile" className="form-label">Gender</label><br/>
                                    <label htmlFor="male" className="me-3">
                                        Male
                                        <Field type="radio" name="gender" id="male" value="male" className="ms-2 form-check-input"  />
                                    </label>
                                    <label htmlFor="female" className="">
                                        Female
                                        <Field type="radio" name="gender" id="female" value="female" className="ms-2 form-check-input" />
                                    </label>
                                </div>
                            </div>
                        </Col>
                    </ModalBody>
                    <ModalFooter>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={toggle}
                        >
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary px-5">
                        {isAddMode==="Add"? "Save":"Update"}
                        </button>
                    </ModalFooter>
                </Form>
             )}
            </Formik>
        </React.Fragment>
    );
}

export default DoctorForm;